import { patchChildJournal, postChildJournal } from 'child-journals/api';
import { Formik, Form, Field } from 'formik';
import { connect } from 'react-redux';

import { object } from 'yup';
import useEntity from 'entities/hooks/use-entity';
import React, { useState } from 'react';
import { Text, Flex, Box } from 'rebass';
import { prepareAttrs } from 'utils/api';
import useMatch from 'app/hooks/match';
import useEntityActionCreators from 'entities/hooks/use-entity-action-creators';
import Wrapper from 'gift-certificate/Wrapper';
import { useCurrentMember } from 'members/hooks/index';
import styled from '@emotion/styled';
import Radio from 'app/form/formik/radio';
import CoverField from 'app/form/formik/cover/index';
import TextField from 'app/form/formik/text/index';
import { relationshipOptions } from 'collections/edit/child-journal/options';
import { uploadMemberAvatar } from 'members/actions';

const StyledForm = styled(Form)`
  display: grid;
  grid-gap: 10px;
  padding: 10px;
`;

const label = (text, isRequired) => <Text
    sx={{
        color: "codGrey",
        fontFeatureSettings: 'liga off, calt off',
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '20px', /* 142.857% */
        letterSpacing: '-0.084px',
    }}> {text} {isRequired && <span style={{ color: 'red' }}>*</span >}</Text >


const UserDetails = ({ hideSkip, onStepUp, childJournalDetails, attributes, renderheader, setChildJournalId, journalId, onStepDown, onLoginPress, redeemCode, ...props }) => {
    const { params } = useMatch();
    const [isSubmitting, setIsSubmitting] = useState(false)
    let { entity: childJournal } = useEntity({ type: 'child-journals', id: params?.id || journalId });

    if (!childJournal || !Object.keys(childJournal).length)
        childJournal = attributes;

    const { receive } = useEntityActionCreators();
    const member = useCurrentMember();

    const initialValues = {
        'member-relation-name': childJournalDetails?.['member-relation-name'] || childJournal?.['member-relation-name'],
        avatar: '',
        'subject-relation-noac': childJournalDetails?.['subject-relation'] || childJournal?.['subject-relation-noac'],
        // 'subject-pronoun': (childJournal && childJournal['subject-pronoun']) || ''
    };

    const validationSchema = object().shape({});

    const isInitialValid = validationSchema.isValidSync(initialValues);

    async function onSubmit({ avatar, ...values }) {
        const attributes = prepareAttrs(values);

        setIsSubmitting(true)
        if (avatar instanceof Blob) {
            await props.uploadMemberAvatar(member.id, avatar);
        }
        let cjRes = null

        const body = {
            data: {
                attributes,
            },
        };

        if (journalId) {
            cjRes = await patchChildJournal({ id: journalId, ...attributes });
        }
        else
            cjRes = await postChildJournal(body);

        const [id] = cjRes.data.result['child-journals'];
        receive({ payload: cjRes });
        setChildJournalId(id)
        onStepUp(id)
        setIsSubmitting(false)
    }

    return (
        <Formik
            {...{ initialValues, validationSchema, isInitialValid }}
            enableReinitialize
            onSubmit={onSubmit}
        >
            {({ handleSubmit }) => (
                <Wrapper
                    hideSkip={false}
                    isSubmitting={isSubmitting}
                    // onHideSkip={async () => {
                    //     onStepUp(journalId)
                    // }}
                    onSubmit={handleSubmit}
                    showFooter
                    onBack={onStepDown}
                    percentComplete={0}
                    bg="aliceBlue"
                    nextButtonText='Continue'
                    renderheader={renderheader}
                >
                    <Flex p={2} m="auto" mb={5} flexDirection="column" maxWidth={487} height={['auto', '100vh']}>
                        <Text
                            color="codGrey"
                            textAlign="left"
                            fontFamily="Bitter"
                            fontSize={30}
                            lineHeight={"120%"}
                            letterSpacing="-0.18px"
                            mt={2}
                            fontWeight={600}
                            mb={1}
                        >
                            About yourself
                        </Text>
                        <StyledForm autoComplete="off">
                            {/* <Box m="auto">
                                <Field name="avatar" component={CoverField} currentCover={member['avatar-image'].id} circular width={150} />
                            </Box> */}
                            <Field
                                component={Radio}
                                name="subject-relation-noac"
                                label={label('Your relationship to the baby:')}
                                placeholder="Gender"
                                options={relationshipOptions}
                                my={1}
                            />
                            {/* <Field
                                component={TextField}
                                name="member-relation-name"
                                label={label("Your name in the book:")}
                                showError
                                placeholder="Ex: Mama, Daddy, Gramps"
                                mb={1}
                            /> */}
                        </StyledForm>

                    </Flex>
                </Wrapper>
            )}
        </Formik>

    );
};

export default connect(null,
    { uploadMemberAvatar }
)(UserDetails);